import Carousel from "react-bootstrap/Carousel";
import EventPoster1 from "../images/EventPoster1.jpg";
import EventPoster2 from "../images/EventPoster2.jpg";
import EventPoster3 from "../images/EventPoster3.jpg";

const Home = () => {
  return (
    <Carousel className="carousel-container">
      <Carousel.Item>
        <a href="http://google.com">
          <img
            className="d-block w-100"
            src={EventPoster1}
            alt="First slide"
            style={{
              width: "100%",
              height: "100%",
              position: "relative",
              margin: "auto",
            }}
          />
        </a>
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="d-block w-100"
          src={EventPoster2}
          alt="Second slide"
          style={{
            width: "100%",
            height: "100%",
            position: "relative",
            margin: "auto",
          }}
        />
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="d-block w-100"
          src={EventPoster3}
          alt="Third slide"
          style={{
            width: "100%",
            height: "100%",
            position: "relative",
            margin: "auto",
          }}
        />
      </Carousel.Item>
    </Carousel>
  );
};

export default Home;
